/** Small display rules for the Price Book screens. */
import Decimal from 'decimal.js';

export type VatBasis = 'VAT_INC' | 'VAT_EX';
export type Currency = 'PHP' | 'USD';

/** A stored decimal string shown in its own currency: ₱10,440.00 or US$12.50. */
export function cost(value: string | null | undefined, currency: Currency | null | undefined = 'PHP'): string {
  if (value === null || value === undefined || value === '') return '—';
  let amount: Decimal;
  try {
    amount = new Decimal(value);
  } catch {
    return '—';
  }
  const [whole, cents] = amount.abs().toFixed(2).split('.');
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${amount.isNegative() ? '-' : ''}${currency === 'USD' ? 'US$' : '₱'}${grouped}.${cents}`;
}

export function vatLabel(basis: VatBasis | null | undefined): string {
  if (basis === 'VAT_INC') return 'VAT-inc';
  if (basis === 'VAT_EX') return 'VAT-ex';
  return '';
}

export function staleLabel(stale: boolean, reason: 'EXPIRED' | 'NOT_YET_VALID' | null | undefined): string | null {
  if (!stale) return null;
  return reason === 'NOT_YET_VALID' ? 'Not yet valid' : 'Stale';
}

/** "02 Jan 2026 – 31 Jan 2026", "from 02 Jan 2026", "until …", or "No end date". */
export function validity(from: string | null | undefined, until: string | null | undefined): string {
  const d = (day: string) => {
    const [y, m, dd] = day.split('-');
    const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][Number(m) - 1];
    return `${dd} ${month} ${y}`;
  };
  if (from && until) return `${d(from)} – ${d(until)}`;
  if (from) return `from ${d(from)}`;
  if (until) return `until ${d(until)}`;
  return 'No end date';
}
